import { Component, Input } from '@angular/core';

import { AttributeValue, Message } from '../core/definition.scorecard.model';
import { ScorecardAttributes } from '../scorecard.model';

import { MessageType } from './messages.model';

@Component({
    selector: 'cmps-messages',
    templateUrl: './messages.component.html',
})
export class CpmsMessagesComponent {
    @Input() messages: Message[];
    @Input() attributes: ScorecardAttributes[];

    availableToShow(message: Message): boolean {
        return this.attributes.some(
            (e) =>
                e.attributeName === message.attributeName &&
                e.attributeValue === 'true',
        );
    }

    showIcon(attribute: AttributeValue): boolean {
        return (
            attribute.displayType === MessageType.WARNING ||
            attribute.displayType === MessageType.ERROR
        );
    }

    classToUse(attribute: AttributeValue): string {
        if (attribute.displayType === MessageType.ERROR) {
            return 'alert-danger';
        } else if (attribute.displayType === MessageType.INFORMATION) {
            return 'alert-info';
        } else {
            return `alert-${attribute.displayType.toLowerCase()}`;
        }
    }
}
